//understand that whenever a parant state changes all the children will re-render
/* eslint-disable react/prop-types */
import React, { useContext, useEffect } from 'react';
import {Context} from '../../../context/dataStore';
import ToolTip from '../../Tooltip';
const { CBTable } = window.cb.apricot;
import TotalUtils from '../../../utils/TotalUtil';
import './index.scss';
import {dataForSelectedMajors, shortenName, DEGREES, checkboxInputUpdate, TableHeaders} from './utils';

const FirstRow = ({ row, allData, selecallcolumns, TdegreeOfferedChange, Utils, readOnly }) => {
  return(
    <tr id='firstrow'>
      { 
        row?.map((cell, index) => (index === 0) ?
          <th id={`delete${index}id`} scope='col' className='col_one' key={`delete${index}`}>
            <div id='deletelink' className='center'>
              <b>Delete</b>
            </div>
          </th>
          : index===1?(
            <th scope='row' className='container-data-outer center' id='degree_col_id' key={`shortName${index}`}>
              <b>
                {shortenName(cell)}
              </b>
            </th>
          )
          : index!==8?(
            <td id={index} className='firstrowcheckbox' key={`firstrowtd${index}`}>
              <div className='center'>
                <label className='label' htmlFor={`firstrowcheckbox__${index}for`}>
                  <input aria-labelledby={`degree_col_id`} 
                    disabled={readOnly}
                    aria-readonly={readOnly}
                    name={DEGREES[index-2]} 
                    value={DEGREES[index-2]}
                    checked={selecallcolumns[index]||false} 
                    id={`firstrowcheckbox_${index}id`} type='checkbox' onChange={
                    e => {
                      //onClick of top degree 
                      TdegreeOfferedChange(index, e.target.checked);
                      Utils.updateSelectedColHeader(allData, index, e.target.checked); 
                    }
                  }
                />
                </label>
              </div>
            </td>
          ):null
        )
      }
    </tr>
  );
};

const TableRow = ({ row, allData, actionDataSentBack, dispatch, setSelectedArray, displayarray, TdegreeOfferedChange, Utils, readOnly }) => {
  return (
    <tr id='otherrows'>
      { 
        row?.map((cell, index) => (index === 0) ?
          <td id={`maj${index}id`} scope='row' className='col_one' key={index}>
            <div className='center deleteCol'>
              <button type="button" className="cb-btn cb-btn-square cb-btn-greyscale cb-btn-close" 
                  disabled={readOnly}
                  aria-readonly={readOnly}
                  onClick={() => {
                    Utils.handleSelectedTableDelete(allData, cell, setSelectedArray);
                    if(!allData?.some(major=>major.boxChecked===true))
                    {
                      dispatch({type: 'SELECT_ALL_COLUMNS', payload: [null, null, null, null, null, null, null, null, null]});
                    }
                    dispatch({type:'SEL_SEARCH_VAL',payload:''});
                  }}
                  key={`${row.org_name}`} aria-labelledby={`tooltip${cell}id`} id={`btn${index}_${cell}`}
              >
                <span className="cb-icon cb-x-mark" aria-hidden="true"></span>
                <span className="sr-only">Close</span>
              </button>
            </div>
          </td>
          : index===1?(
            <th scope='row' className='container-data-outer center' id={cell[1]} key={index}>
              <ToolTip tooltipid={`tooltip${cell[1]}id`} tooltipMsg={cell[0]} innerMsg={shortenName(cell[0])} />
            </th>
          )
          : index!==8?(
            <td id={index} key={index}>
              <div className='center'>
                <label className='label'>
                  <input aria-labelledby={`tooltip${cell[1]}id`} 
                    disabled={readOnly}
                    aria-readonly={readOnly}
                    checked={!!checkboxInputUpdate(displayarray, index, cell[1])}
                    key={`chb${cell[1]}_${index}key`}
                    id={`chb${cell[1]}_${index}id`} 
                    onChange={
                      e => {
                      //update each cell as you click it.
                        Utils.updateIndividualCheck(displayarray, index, e.target.checked, cell[1]);
                        const res = Utils.truthyCheck(displayarray, true, index);
                        if(res.every(el => el === true)){
                          TdegreeOfferedChange(index, true);
                        }else {
                          TdegreeOfferedChange(index, null);
                        }
                      }
                    } 
                    type='checkbox' />
                </label>
              </div>
            </td>
          ):null
        )
      }
    </tr>
  );
};

const Table = ({displayarray, actionDataSentBack, allData, setSelectedArray, readOnly}) => {
  const Utils = new TotalUtils();
  const {state:{ selecallcolumns }, dispatch} = useContext(Context);
  useEffect(() => {
    document.querySelectorAll('.cb-table-responsive').forEach(elem => {
      CBTable.customScrollbar({
        elem
      });
    });
  });

  const TdegreeOfferedChange = (ind, val, id) => {
    const newarr = selecallcolumns;
    newarr[ind] = val;
    return dispatch({type: 'SELECT_ALL_COLUMNS', payload: [...newarr]});
  };
 
  return (
    <div className='cb-scrollbar-container majors-second-table'>
      <div className='cb-scrollbar cb-top'>
        <div className='cb-scrollbar-thumb' />
      </div>
      <div className='cb-table-responsive' id='majorssecondtable-container'>
        <table className='cb-table cb-table-condensed cb-table-striped-reverse'>
          {displayarray.length >= 0? <TableHeaders />: null}
          <tbody>
            {
              displayarray.length >= 0?dataForSelectedMajors(displayarray)?.map((row, index) => index===0?
              <FirstRow key={`firstrow${index}`} row={row} allData={allData} selecallcolumns={selecallcolumns} TdegreeOfferedChange={TdegreeOfferedChange} Utils={Utils} readOnly={readOnly}/>
              :<TableRow key={`tableRow${index}`} row={row} allData={allData} actionDataSentBack={actionDataSentBack} displayarray={displayarray} dispatch={dispatch} setSelectedArray={setSelectedArray} TdegreeOfferedChange={TdegreeOfferedChange} Utils={Utils} readOnly={readOnly}/>):null
            }
          </tbody>
        </table>
        {
          displayarray.length===0?
          <p id='nomajselected'>No selected majors, search below for majors</p>:
          null
        }
      </div>
      <div className='cb-scrollbar cb-bottom'>
        <div className='cb-scrollbar-thumb' />
      </div>
    </div>
  );
};
export default Table;
